import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { setSimParam, getSimParam } from "./utils.js";

import { PlayFill, PauseFill } from "react-bootstrap-icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Collapse from "react-bootstrap/Collapse"

import CallButton from "./CallButton.js";
import Line from "./Line.js";
import GroupCode from "./GroupCode.js";
import MyButton from "./MyButton.js";

const withCallButtons = false;

export default function AdminPanel (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    // CODES
    const [showCodes, setShowCodes] = useState(true);
    function handleShowCodes () { setShowCodes(!showCodes); }

    const codeList = Object
	.entries(gData.group)
	.filter(([id, group]) => { return group.simID === gData.simID && group.selected === 1; })
	.sort(([id1, group1], [id2, group2]) => group1.rank - group2.rank)
	.map(([id, group]) => {
	    return (
		<Row key={group.groupID} className="py-1 align-items-center">
		    <Col xs={5} className="text-uppercase small">{group.title}</Col>
		    <Col xs={3} className="fw-medium"><GroupCode code={group.code}/></Col>
		    <Col xs={4}><GroupCode code={group.code} copylink/></Col>		    
		</Row>
	    );
	});
    

    // PAUSE BUTTON

    const pause = getSimParam(gData, "pause");

    function setPause () { if (!pause) setSimParam(gData, gDispatch, "pause", true); }
    function unsetPause () { if (pause) setSimParam(gData, gDispatch, "pause", false); }
    //function togglePause () { if (pause) unsetPause(); else setPause(); }

    const pauseButtons = (
	<ButtonGroup>
	    <ToggleButton type="radio" variant="outline-primary" checked={!pause} size="sm" onClick={unsetPause}><PlayFill/> Lecture</ToggleButton>
	    <ToggleButton type="radio" variant="outline-secondary" checked={pause} size="sm" onClick={setPause}><PauseFill/> Pause</ToggleButton>
	</ButtonGroup>
    );

    
    // CALL BUTTONS
    const [showCalls, setShowCalls] = useState(false);
    function handleShowCalls () { setShowCalls(!showCalls); }

    const callButtons = [];

    Object.entries(gData.group)
	  .filter(([id, group]) => { return group.simID === gData.simID && group.type !== "admin" && group.selected === 1; })
	  .sort(([id1, group1], [id2, group2]) => group1.rank - group2.rank)
	  .forEach(([id, group]) => { callButtons.push(<CallButton key={group.groupID} groupID={group.groupID} size="sm" />); });



    return (
	<>
	    <Offcanvas show={props.show} onHide={props.hide} placement="end" backdrop={true} scroll={true}>
		<Offcanvas.Header className="bg-light" closeButton>
		    <Offcanvas.Title className="text-uppercase fw-normal">Panneau d'administration</Offcanvas.Title>
		</Offcanvas.Header>
		<Offcanvas.Body className="d-flex flex-column gap-3">
		    <div className="w-100 d-flex justify-content-between align-items-center">
			<div className="text-uppercase text-muted fs-5">{pause ? (<span>Jeu en pause...</span>) : (<span>Jeu en cours !</span>)}</div>
			{pauseButtons}
		    </div>
		    <Line/>
		    {withCallButtons && (
			<>
			    <div>
				<div className="w-100 d-flex justify-content-between align-items-center">
				    <div className="text-uppercase text-muted fs-5">Appeler des groupes</div>
				    <MyButton icon={showCalls ? "readLess" : "readMore"} variant="outline-secondary" onClick={handleShowCalls}/>
				</div>
				<Collapse in={showCalls}>
				    <div className="py-2">
					<div className="d-flex gap-2 flex-wrap">{callButtons}</div>
				    </div>
				</Collapse>
			    </div>
			    <Line/>
			</>
		    )}
		    <div>
			<div className="w-100 d-flex justify-content-between align-items-center">
			    <div className="text-uppercase text-muted fs-5">Connexion des groupes</div>
			    <MyButton icon={showCodes ? "readLess" : "readMore"} variant="outline-secondary" onClick={handleShowCodes}/>
			</div>
			<Collapse in={showCodes}>
			    <div className="py-2">
				<div>Chaque groupe doit se rendre à l'adresse suivante et entrer son code d'accès personnel.</div>
				<div className="text-center pt-1 pb-3 fs-5"><GroupCode fulllink/></div>
				{codeList}
			    </div>
			</Collapse>
		    </div>
		</Offcanvas.Body>
	    </Offcanvas>
	</>
    );
}
